import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  paginationContainer: {
    display: 'flex',
    listStyleType: 'none',
    padding: '0',
    '& .paginationItem': {
      padding: '0 12px',
      height: '32px',
      textAlign: 'center',
      margin: 'auto 4px',
      color: theme.colors['grey-400'],
      display: 'flex',
      boxSizing: 'border-box',
      alignItems: 'center',
      letterSpacing: '0.01071em',
      borderRadius: '4px',
      lineHeight: '1.43',
      fontSize: '14px',
      minWidth: '32px',
      fontWeight: 400,

      '&.dots:hover': {
        backgroundColor: 'transparent',
        cursor: 'default',
      },
      '&:hover': {
        backgroundColor: theme.colors['secondary-light'],
        cursor: 'pointer',
      },

      '&.selected': {
        color: theme.colors['secondary-200'],
        border: `1px solid ${theme.colors['secondary-200']}`,
        fontWeight: 700,
      },

      '& .arrow': {
        '&::before': {
          position: 'relative',
          content: "''",
          display: 'inline-block',
          width: '0.4em',
          height: '0.4em',
          borderRight: `0.12em solid ${theme.colors['grey-400']}`,
          borderTop: `0.12em solid ${theme.colors['grey-400']}`,
        },
        '&.left': {
          transform: 'rotate(-135deg) translate(-50%)',
        },
        '&.right': {
          transform: 'rotate(45deg)',
        },
      },

      '&.disabled': {
        color: 'red',
        pointerEvents: 'none',

        '& .arrow::before': {
          borderRight: `0.12em solid ${theme.colors['grey-100']}`,
          borderTop: `0.12em solid ${theme.colors['grey-100']}`,
        },
        '&:hover': {
          backgroundColor: 'transparent',
          cursor: 'default',
        },
      },
    },
  },
  buttonPerPage: {
    border: `${theme.colors['grey-400']} !important`,
  },
}))
